import Route from '@ember/routing/route';

export default class AuthenticatedReimaginedCollegePlanningRoute extends Route {}
